import type { UI } from '@/v2/types';
import React from 'react';

import { Inclusion } from '@shared/types/client/ProcuredOffer';
import ToggleContent from '@shared/v2/components/ToggleContent';

import LinkButton from '@/components/LinkButton';
import Text from '@/components/Text';
import ViewDetailsModal from '@/components/ViewDetailsModal';
import { LeadInOffer } from '@/v2/services/sanity/types/api/parsedResponse';
import { InclusionItem } from '../PackageInclusions/Inclusion';

export type PackageDetailsProps = {
  propertyContent: UI.Property;
  procuredOffer?: UI.ProcuredOffer;
  leadInOffer?: Pick<LeadInOffer, 'minNumberOfNights'>;
  inclusions: Array<InclusionItem | Inclusion>;
};

const PackageDetails = ({
  propertyContent,
  procuredOffer,
  leadInOffer,
  inclusions,
}: PackageDetailsProps) => {
  if (!procuredOffer || !leadInOffer) {
    return null;
  }

  const { destination, name } = propertyContent;

  return (
    <ToggleContent
      toggle={(show) => (
        <LinkButton
          data-testid="PACKAGE_DETAILS_BUTTON"
          noPadding
          onClick={show}
        >
          <Text bold link fontSize={['xs', null, 'sm']}>
            View package details and terms
          </Text>
        </LinkButton>
      )}
      content={(close) => (
        <ViewDetailsModal
          close={close}
          title={`Holiday package to ${destination.title} at ${name}`}
          terms={procuredOffer.terms ?? ''}
          inclusions={inclusions}
          routes={procuredOffer?.routes}
          destinationCode={destination.searchConfig?.destinationCode}
          travelDateRange={procuredOffer?.travelDateRange}
          minNights={leadInOffer.minNumberOfNights}
        />
      )}
    />
  );
};

export default PackageDetails;
